import { Draft, PayloadAction } from '@reduxjs/toolkit';
import formatters from 'formatters';

import { timelineTraderActions } from 'constants/intervention/timelineTraderActions';

import IEditInterventionResponse from 'services/httpClient/responses/intervention/IEditInterventionResponse';

import { IInterventionData } from '../../initialState';

interface IEditInterventionSuccessAction {
  intervention: IEditInterventionResponse;
}

function editSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IEditInterventionSuccessAction>,
) {
  draft.edit.config.isLoading = false;
  draft.getDetails.values = {
    noRepair: action.payload.intervention.no_repair,
    availableActions: action.payload.intervention.available_actions,
    created_at: formatters.date(action.payload.intervention.created_at),
    category: action.payload.intervention.category,
    categoryFr: action.payload.intervention.category_fr,
    categoryId: action.payload.intervention.category_id,
    categoryNl: action.payload.intervention.category_nl,
    claimId: action.payload.intervention.claim_id,
    companyName: action.payload.intervention.companyname,
    email: action.payload.intervention.email,
    firstVisitDate: action.payload.intervention.first_visit_date,
    firstVisitDateUpdatedAt:
      action.payload.intervention.first_visit_date_updated_at,
    id: action.payload.intervention.id,
    interventionPartnershipId:
      action.payload.intervention.intervention_partnership_id,
    interventionType: action.payload.intervention.intervention_type,
    invoiceInsurerStatus: action.payload.intervention.invoice_insurer_status,
    invoiceNumber: action.payload.intervention.invoice_number,
    invoiceValueCents: action.payload.intervention.invoice_value_cents,
    mobilePhone: action.payload.intervention.mobile_phone,
    notes: action.payload.intervention.notes.map(note => ({
      createdAt: formatters.date(note.created_at, { formatType: 'DD/MM/YYYY' }),
      id: note.id,
      text: note.text,
      wroteBy: note.wrote_by,
    })),
    previousNonWhiteStatus:
      action.payload.intervention.previous_non_white_status,
    priceExclVat: action.payload.intervention.price_excl_vat,
    quoteApproved: action.payload.intervention.quote_approved,
    quoteUpdatedAt: action.payload.intervention.quote_updated_at
      ? formatters.date(action.payload.intervention.quote_updated_at)
      : '--/--/----',
    quoteUpdatedBy: action.payload.intervention.quote_updated_by,
    quoteValueCents: action.payload.intervention.quote_value_cents,
    repairDate: action.payload.intervention.repair_date,
    repairDateUpdatedAt: action.payload.intervention.repair_date_updated_at,
    repairEndDate: action.payload.intervention.repair_end_date,
    status: action.payload.intervention.status,
    traderId: action.payload.intervention.trader_id,
    traderName: action.payload.intervention.trader_name,
    vatPercentage: action.payload.intervention.vat_percentage,
    timeline: timelineTraderActions.filter(timelineTraderAction =>
      timelineTraderAction.interventionType(
        action.payload.intervention.intervention_type,
      ),
    ),
  };
}

export default editSuccess;
